import React from "react";
import Layout from "./src/components/Layout";
import { LanguageProvider } from "./src/container/language";
import { I18nextProvider } from "react-i18next";
import { PageContextProvider } from "./src/utils/PageContext";

import i18n from "./src/utils/i18n";

export function wrapPageElement({ element, props }) {
  console.log("props.pageContext", props.pageContext);
  return (
    <PageContextProvider pageContext={props.pageContext}>
      <Layout {...props}>{element}</Layout>
    </PageContextProvider>
  );
}

export function wrapRootElement({ element }) {
  return (
    <I18nextProvider i18n={i18n}>
      <LanguageProvider>{element}</LanguageProvider>
    </I18nextProvider>
  );
}

// Strip the "Gatsby x.y.z" generator tag so the framework version is not
// disclosed in the built HTML (AKSK security finding).
export function onPreRenderHTML({ getHeadComponents, replaceHeadComponents }) {
  replaceHeadComponents(
    getHeadComponents().filter(
      (component) =>
        !(
          component &&
          component.type === "meta" &&
          component.props &&
          component.props.name === "generator"
        )
    )
  );
}
